import React, { useState } from 'react';

/**
 * A button that requires a second click to confirm destructive actions.
 * Shows "Are you sure?" inline after first click, reverts after timeout.
 */
export function ConfirmButton({ onConfirm, label = 'Delete', confirmLabel = 'Confirm?', className = 'btn xs danger-outline', timeout = 3000, disabled = false }) {
  const [confirming, setConfirming] = useState(false);
  const [running, setRunning] = useState(false);

  async function handleClick() {
    if (!confirming) {
      setConfirming(true);
      setTimeout(() => setConfirming(false), timeout);
      return;
    }
    setRunning(true);
    try {
      await onConfirm();
    } catch (e) {
      console.error('ConfirmButton action failed:', e);
    }
    setRunning(false);
    setConfirming(false);
  }

  return (
    <button
      className={className}
      onClick={handleClick}
      disabled={disabled || running}
      style={confirming ? { borderColor: 'var(--red)', background: 'rgba(192,57,43,.15)' } : undefined}
    >
      {running ? '…' : confirming ? confirmLabel : label}
    </button>
  );
}
